import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import imgDropDown from '../../images/common/arrow_drop_down_black_24dp.svg';
import imgDropUp from '../../images/common/arrow_drop_up_black_24dp.svg';
import SelectGroupDialog from '../SelectGroupDialog/SelectGroupDialog';
import config from '../../config/index';
import {
  Wrapper,
  CompanyArea,
  CompanyNameArea,
  GroupArea,
  GroupNameWrapper,
  GroupTitle,
  InputTextField,
  GroupDialogWrapper,
  DialogBackground,
  GroupName,
  DropDownImage,
} from './styles/ToolBarStyles';

const ToolBar = ({ hidden, companyName, groupName, onSelect }) => {
  const userGroups = useSelector(state => state.main.userGroups);
  const fullScreenMode = useSelector(state => state.main.fullScreenMode);
  const [showSetGroupDialog, setShowSetGroupDialog] = useState(false);
  const onSelectGroup = groupId => {
    onSelect(groupId);
    setShowSetGroupDialog(false);
  };

  return (
    <Wrapper hidden={hidden}>
      <CompanyArea>
        <CompanyNameArea>{companyName}</CompanyNameArea>
      </CompanyArea>
      {config.GROUP_SELECT_BOX_DISPLAY_MODES.includes(fullScreenMode) && (
        <GroupArea>
          <GroupNameWrapper>
            <GroupTitle>
              <FormattedMessage id="toolbar.group.title" />
            </GroupTitle>
            <GroupName
              onClick={() => setShowSetGroupDialog(!showSetGroupDialog)}
            >
              <InputTextField
                id="SetGroupTextField"
                type="text"
                value={groupName}
                readOnly
              />
              <DropDownImage
                src={(showSetGroupDialog && imgDropUp) || imgDropDown}
                alt=""
              />
            </GroupName>
          </GroupNameWrapper>
        </GroupArea>
      )}
      {showSetGroupDialog && (
        <GroupDialogWrapper>
          <DialogBackground onClick={() => setShowSetGroupDialog(false)} />
          <SelectGroupDialog
            groups={userGroups}
            onClick={e => e.stopPropagation()}
            onSelect={groupId => onSelectGroup(groupId)}
          />
        </GroupDialogWrapper>
      )}
    </Wrapper>
  );
};

ToolBar.propTypes = {
  /** ツールバー非表示フラグ */
  hidden: PropTypes.bool,
  /** 現在の表示対象企業名 */
  companyName: PropTypes.string.isRequired,
  /** 現在の表示対象グループ名 */
  groupName: PropTypes.string.isRequired,
  /** グループ選択処理 */
  onSelect: PropTypes.func.isRequired,
};
ToolBar.defaultProps = {
  hidden: false,
};
export default withRouter(ToolBar);
